
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as emailY_AU4bmNwO0ufOm9bKxdEuDHE6oUGO_45XanjQssbVpfoMeta } from "/vercel/path0/pages/email.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as users_45hC4_hJ8eydernQZEfkcZ_sZfpk59rJ75zXql47lvAEMeta } from "/vercel/path0/pages/users.vue?macro=true";
import { default as _91token_930VRPgwMzhH9XwK4jQdRZJrEePo16q490OHAsEVdZTE0Meta } from "/vercel/path0/pages/u/[token].vue?macro=true";
import { default as indexbew0nVKwsfyGVoxhAN2SO3WGVpn50EmGjMwWLpTQ1uAMeta } from "/vercel/path0/pages/tasks/index.vue?macro=true";
import { default as profileTrvz1mgM0EtfJ9lqv_45LQ0sabEUXAy_ibAHvOKDcswegMeta } from "/vercel/path0/pages/auth/profile.vue?macro=true";
import { default as sign_45inAeSXm7rLcm3lADB0JgQ0enjQKXtwBcUIqQwii7CxY8IMeta } from "/vercel/path0/pages/auth/sign-in.vue?macro=true";
import { default as unauthorizedK0eKq87Ipcr1dfJimqi2XLyXRh97Jx31XMqzIc4bbQcMeta } from "/vercel/path0/pages/unauthorized.vue?macro=true";
import { default as business_45statsnYcz_45Sg8GUtQHJJVWG0WVi2gjlcefiAVLsw6YGxj0r0Meta } from "/vercel/path0/pages/business-stats.vue?macro=true";
import { default as index5XBmGkYt_45HFVtTt2RhtlIcl3hPZ6S3KpEutULHXLHZAMeta } from "/vercel/path0/pages/calendar/index.vue?macro=true";
import { default as index_GPxegkpWxejqXMN4j5bT3BJDAGPg59HepgRYyiggqoMeta } from "/vercel/path0/pages/campaign/index.vue?macro=true";
import { default as indexu6VUi26XJSPeygrbo1TLgQRYPQYEXunCoL_45tmff89dMMeta } from "/vercel/path0/pages/contacts/index.vue?macro=true";
import { default as exchange661bhJS583nflQmXH5Y7GKUdA16aPwm4_45I_TTNNWB1QMeta } from "/vercel/path0/pages/oauth/exchange.vue?macro=true";
import { default as indexKQbcR6Z_4513okR_45dWY6AuA_45EA7vL6gINFw1DPONCtsRgMeta } from "/vercel/path0/pages/pipeline/index.vue?macro=true";
import { default as privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta } from "/vercel/path0/pages/privacy-policy.vue?macro=true";
import { default as brandF8XU3_CcKfxJAQI4NQoIfzoXJ78XHwoM_b4Jh8Oq4ssMeta } from "/vercel/path0/pages/settings/brand.vue?macro=true";
import { default as indexv1fFzc2ShcljiGo28Bo2KD8xzvwNrH7uZVZ3jm__I8gMeta } from "/vercel/path0/pages/settings/index.vue?macro=true";
import { default as workspaces0cn2qnvuwNdSOycWVrnYQ9aDRp2zcqhfDoS4W__4533WIMeta } from "/vercel/path0/pages/auth/workspaces.vue?macro=true";
import { default as createlG5zxNqJwWhreOcfuIMRj16lA6OMZXri4Th_45R1mQHdIMeta } from "/vercel/path0/pages/campaign/create.vue?macro=true";
import { default as indexcBROvFFJHJZK4mS2aabeLqmZPI_45iJDpLkmbAeBvTujUMeta } from "/vercel/path0/pages/contracts/index.vue?macro=true";
import { default as indexczqb894Rrptdre7iLZ86SFXmfR9zfWOMvkAXxsE7bgMMeta } from "/vercel/path0/pages/data-room/index.vue?macro=true";
import { default as index_45SxPpf9CL7T2yY3RiaZ0pGGqQraQq4KVzxft0sdwROQMeta } from "/vercel/path0/pages/templates/index.vue?macro=true";
import { default as _91id_93rEONDoQiE79kBDm6XcfRc_45jaS9cHrGqzuBkyz7XDAGYMeta } from "/vercel/path0/pages/auth/invite/[id].vue?macro=true";
import { default as indext63iqvUuoErJGDrZDC0evR8vIviUjHw77KkWwCI9ozgMeta } from "/vercel/path0/pages/businesses/index.vue?macro=true";
import { default as redeem7PqwaR5F4q2ptMXieuLH8IR4wLkEHPnT6akEGkiweroMeta } from "/vercel/path0/pages/data-room/redeem.vue?macro=true";
import { default as _91id_93uMVwxvjG__45LYd0iNmuDtPw45H_kJGvKcfiZim5Za71gMeta } from "/vercel/path0/pages/page-access/[id].vue?macro=true";
import { default as billingb83Bs9cMUtNzaecR4ZtHkxs0OKXE3HAVmWrYFjkc_45U8Meta } from "/vercel/path0/pages/settings/billing.vue?macro=true";
import { default as indexrEL8rxfs1ogqcD5OQCsdsOGMn5IXhDijcp8LH_PxhKoMeta } from "/vercel/path0/pages/automations/index.vue?macro=true";
import { default as expiredzIQQuwxnfvylWXWmD_98vUUHznjMovrM7vQcZmn4ErgMeta } from "/vercel/path0/pages/data-room/expired.vue?macro=true";
import { default as sign_45inl7EhC8W14trRKgrpz5MQ5wr8Jm2HlqXpA1uwX6IRpD8Meta } from "/vercel/path0/pages/data-room/sign-in.vue?macro=true";
import { default as businesspThAUmSvYp6KbNS5av2VO2EfBIEKLEN7aSo2dcrP3WYMeta } from "/vercel/path0/pages/settings/business.vue?macro=true";
import { default as featuresaednd1HDFRBhPUti1SP5Yb_45pJRar_lO6g7qkK6aq_451QMeta } from "/vercel/path0/pages/settings/features.vue?macro=true";
import { default as listingswMUPBReVImpzKm1_452k3BDvMzSCLoZEr19zHzEp79NfUMeta } from "/vercel/path0/pages/settings/listings.vue?macro=true";
import { default as foldersvRMB3KouJlnik1kk_458mSxBK5Zv8yOBaA4bZWuicBPOcMeta } from "/vercel/path0/pages/templates/folders.vue?macro=true";
import { default as indexwP03gWLiuIGVzQ1MhFUb8GR07mYYi95OsCS71UM_vWkMeta } from "/vercel/path0/pages/campaign/[id]/index.vue?macro=true";
import { default as indexY75mSzdpBxLDG_45PWRuGu2ZQKwE281eaZLkLWxi9d8qUMeta } from "/vercel/path0/pages/templates/cim/index.vue?macro=true";
import { default as newTanyP_dRtsKPWTnzN_45H7hc8egylzK0xZG6hartNNZUoMeta } from "/vercel/path0/pages/templates/forms/new.vue?macro=true";
import { default as resourcesNbsgHUKeq_45Lh6wQhNDU5FRhnVzhkaToeKOdIwn_45Bu3MMeta } from "/vercel/path0/pages/templates/resources.vue?macro=true";
import { default as forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta } from "/vercel/path0/pages/auth/forgot-password.vue?macro=true";
import { default as filescXeN7trZn3gmRrd4WufmqqxVK_45n3JwMpfsA_45N_v3_HYMeta } from "/vercel/path0/pages/contracts/[id]/files.vue?macro=true";
import { default as caSLr1BnUYHQLXN0422h8dDuZhcSkUmMGshb96XHRA3vcMeta } from "/vercel/path0/pages/public/[publicId]/ca.vue?macro=true";
import { default as integrationKcPoiVKHxVz6KaWGXCGDJk_45eO9wRBAK120tvCugdtAAMeta } from "/vercel/path0/pages/settings/integration.vue?macro=true";
import { default as _91id_93A5XP_45x0iIkuq3UJsEgI04zkOa9JnkQvCTpBXSayQLJgMeta } from "/vercel/path0/pages/templates/forms/[id].vue?macro=true";
import { default as industriessVT8h8o43CJeJhTWkeQyHfUtFosvF00LTFriWn93_45tEMeta } from "/vercel/path0/pages/templates/industries.vue?macro=true";
import { default as terms_45and_45conditions0uoxVtwK_45tSMS21tRu9yb6U_45zGTAUTRZuYF7psIZXqsMeta } from "/vercel/path0/pages/terms-and-conditions.vue?macro=true";
import { default as cim5bPFTPS8SP_45LveDEPw8APP5VIFBQscn6i_UJWaFFZPMMeta } from "/vercel/path0/pages/public/[publicId]/cim.vue?macro=true";
import { default as _91cimId_93bDMp0NiOw1ypyIf0rvWU0UVo08CC3QuxsHyzOG42v3QMeta } from "/vercel/path0/pages/templates/cim/[cimId].vue?macro=true";
import { default as indexk5Fq2_d0Btb_qfF1zklG7b00LAF1ql3Y3Da90rvGoAYMeta } from "/vercel/path0/pages/templates/forms/index.vue?macro=true";
import { default as details5iitdEX3tLk2ls9JWWUW3tHUKfcUb_5Z7V2ZCZt7KSQMeta } from "/vercel/path0/pages/contracts/[id]/details.vue?macro=true";
import { default as index9wYZ4YK6fLdCidEsUvqMZMz3QnUGgODiwpyhLeQFrC8Meta } from "/vercel/path0/pages/templates/teaser/index.vue?macro=true";
import { default as index_tXkFjgaWZQ7N4xjn_45_45LOWJ3ipqYjxQCG7sQWAUNvBEMeta } from "/vercel/path0/pages/trust-accounting/index.vue?macro=true";
import { default as activity_45GO0bCxJZruKWLf5YiKGKelgbfLyqAJsGY28zzaIrn0Meta } from "/vercel/path0/pages/contracts/[id]/activity.vue?macro=true";
import { default as authenticationw2ApG0hJeS_45qn436uxf7f0kksQz642YJv8lPXSHpWiwMeta } from "/vercel/path0/pages/settings/authentication.vue?macro=true";
import { default as index_45Gem6qaZmh_uN_45uIsuL81Fpxjig2_45EF5cyY7kGuWuuEMeta } from "/vercel/path0/pages/templates/message/index.vue?macro=true";
import { default as _91id_93fv0EZ1pYp3YXrYd1NYWPDxwoWLuv6yrhF_45LJPRsEL_wMeta } from "/vercel/path0/pages/templates/proposal/[id].vue?macro=true";
import { default as teasereXu8iOfba_45IGkAXoStp8Es0ueXxbL5KOf8CgwSP316MMeta } from "/vercel/path0/pages/public/[publicId]/teaser.vue?macro=true";
import { default as indexBUXia09MW2EtmVnp3tECSLDf0zx1E9jzd079WZ_45KnbMMeta } from "/vercel/path0/pages/templates/proposal/index.vue?macro=true";
import { default as email_45complianceGUSH2Rs3UrT337hPPw2Cq8Y9EwcJqC2bg9aaWRdaC5QMeta } from "/vercel/path0/pages/settings/email-compliance.vue?macro=true";
import { default as indexY03zcM_K9_4541hbQ2PCn9OPpgnNcQ_P6p1y7s_45bEhVUgMeta } from "/vercel/path0/pages/templates/appraisal/index.vue?macro=true";
import { default as proposalz3GDZSVWEZYX_MymSMPjsbkt6EXSMyh6T0IUTRi_VysMeta } from "/vercel/path0/pages/public/[publicId]/proposal.vue?macro=true";
import { default as transactionsavue2bn_45hvUFb_BD4m9MIDkfrr0_QfI55pmO6_45ZeRnEMeta } from "/vercel/path0/pages/contracts/[id]/transactions.vue?macro=true";
import { default as appraisalYS0eMI3c7NcLaj9yO99qdEiF5yO76Ht4emmG9kbGNmoMeta } from "/vercel/path0/pages/public/[publicId]/appraisal.vue?macro=true";
import { default as _91teaserId_93_qAzEPydN1EPjEn0cfRt8pX0t3scCESof5QNaTZ0pncMeta } from "/vercel/path0/pages/templates/teaser/[teaserId].vue?macro=true";
import { default as indexBXHoRaw5IBQKFJLdhKxMDw6MLQ8Paf0T2gBwOfFeA_oMeta } from "/vercel/path0/pages/trust-accounting/[id]/index.vue?macro=true";
import { default as profile4aI4jykUj6PdLdO7NBzQZ6C42XpTKE_PjdGk151K8bEMeta } from "/vercel/path0/pages/contacts/[contactId]/profile.vue?macro=true";
import { default as public_45cimlCNf49riXn83S3OzQfh21jDYJQNJ36zM6UW44TKuzxIMeta } from "/vercel/path0/pages/public/[publicId]/public-cim.vue?macro=true";
import { default as forgot_45password_45callbackwvXI1oTz2BPssbRqs_tybIP2PxdJLiLn_451z2tvnpGI0Meta } from "/vercel/path0/pages/auth/forgot-password-callback.vue?macro=true";
import { default as activityUrh38EUilOOtEMJH1cxq9EJQiPPFIjkDKilSUSdsrZAMeta } from "/vercel/path0/pages/contacts/[contactId]/activity.vue?macro=true";
import { default as file_45uploadCJ_xRxbneczffDnMfmr8PuzRSWHjkPMGWocMmxN7vzkMeta } from "/vercel/path0/pages/public/[publicId]/file-upload.vue?macro=true";
import { default as automationAzQSmK_TwhODXkkOx_45PS_45ufZsEUilpuGhDt92eY4h34Meta } from "/vercel/path0/pages/contacts/[contactId]/automation.vue?macro=true";
import { default as buyer_45profileb60sIKfnshtS_VEHQbtWPt2oRrgo6RH_455K0ser3XwhwMeta } from "/vercel/path0/pages/public/[publicId]/buyer-profile.vue?macro=true";
import { default as vendor_45reportDmiZpzTMdAA_2_hlC0XeXQex_qZQcNlVmaIX3Js1YdQMeta } from "/vercel/path0/pages/public/[publicId]/vendor-report.vue?macro=true";
import { default as indexj35ZinTuQMyvc10RXbhUKhfDYgi0rCh09QkGxsRxySMMeta } from "/vercel/path0/pages/automations/[automationId]/index.vue?macro=true";
import { default as listingscSMEtcJBF1tcjz14HVcUJ1LXCdnVBgULhRpFtrZzU8EMeta } from "/vercel/path0/pages/public/[publicId]/embed/listings.vue?macro=true";
import { default as appraisalMtpTnWDID5Wk6nwrkrVWRyt19MARWPOjMBblqS6JubkMeta } from "/vercel/path0/pages/businesses/[businessId]/appraisal.vue?macro=true";
import { default as index17vG__2BoXD25cpuiCWCjTVjEXylMCV0eusz39i4Am0Meta } from "/vercel/path0/pages/businesses/[businessId]/cim/index.vue?macro=true";
import { default as file_45upload_45oldrYGNyCs3VBAFBZ7zAFySV04WgYL9pDak9AplqmFRW98Meta } from "/vercel/path0/pages/public/[publicId]/file-upload-old.vue?macro=true";
import { default as indexay4IrCx9SmYsYLz_qxxV_45MnaNem2jWgtMz4wuoCyVMIMeta } from "/vercel/path0/pages/templates/business-campaign/index.vue?macro=true";
import { default as vdrgFE4bgftp6gtCBW3NtqZWr14b1HRqqeBtTLkSx9zBIAMeta } from "/vercel/path0/pages/businesses/[businessId]/details/vdr.vue?macro=true";
import { default as indexQi1KjCykauI3BPNH0ujeBp_45p0S7clzo581WEs6q4QnYMeta } from "/vercel/path0/pages/businesses/[businessId]/teaser/index.vue?macro=true";
import { default as _91id_93TGNCjoG0S3Iffa_45EezN3apBh7oAkDLd1EEnFk9Gtz68Meta } from "/vercel/path0/pages/trust-accounting/bank-statement/[id].vue?macro=true";
import { default as advanced_45profile0zHqn5QWuz640nlWwwbYgVYhtTx7U2JQ6SV8DAjwhAYMeta } from "/vercel/path0/pages/contacts/[contactId]/advanced-profile.vue?macro=true";
import { default as teaserUQJpBodaNKjpDpv1hhvfCSdX1pUU0Xk5GODHKdgTnoYMeta } from "/vercel/path0/pages/businesses/[businessId]/details/teaser.vue?macro=true";
import { default as indexGMQqxOMaww5BAJP8rM0IEpJYTlt_45CO0_45xIz77pj4xf4Meta } from "/vercel/path0/pages/businesses/[businessId]/proposal/index.vue?macro=true";
import { default as indexo8oYS20bngUSqbqWTLEl7pITnNVKr6gknn12Ro7lDooMeta } from "/vercel/path0/pages/automations/[automationId]/events/index.vue?macro=true";
import { default as profileLb7ikmtg03EPgB7TamGHKbI4lerMW5S9MuIQzNj4qZ4Meta } from "/vercel/path0/pages/businesses/[businessId]/details/profile.vue?macro=true";
import { default as sharing8PV3u5_8tSLX03OjVmfijF3x5Wd0Fce8jQOLQxd3vOoMeta } from "/vercel/path0/pages/businesses/[businessId]/details/sharing.vue?macro=true";
import { default as recorderXVHTZGB5wdHL2ho5ZoL1i1vzZHAKBm0NTN4V_BZxqY0Meta } from "/vercel/path0/pages/businesses/[businessId]/details/recorder.vue?macro=true";
import { default as indexn1MnEUh_45plrXMPSBuyOBJ_45UBScrBT_45brM9jsWHOoBc8Meta } from "/vercel/path0/pages/trust-accounting/ledger/[ledgerId]/index.vue?macro=true";
import { default as _91id_93Z_ti9nadJUsWpbDet1kUTK9y0EhCj1eHVwdznOwbbvAMeta } from "/vercel/path0/pages/trust-accounting/ledger/transaction/[id].vue?macro=true";
import { default as analyticsWubLrN1ch_JAEuzVc27NpPIeFkJNn0LKVK6ojuOaVz8Meta } from "/vercel/path0/pages/businesses/[businessId]/details/analytics.vue?macro=true";
import { default as indexzNvj00bacJkaeqABj__vccp_45petnkcbgtmnUH62aaYYMeta } from "/vercel/path0/pages/templates/confidentiality-agreement/index.vue?macro=true";
import { default as file_45sharingub1XUBE9Aez1xCPyiVYHRVLvbeHU1Z_CCMDOVcKdzCIMeta } from "/vercel/path0/pages/businesses/[businessId]/details/file-sharing.vue?macro=true";
import { default as index2ngvYzCNiU3gZwe31mrknqs_65F0chrR9zg1tMQ8bWAMeta } from "/vercel/path0/pages/businesses/[businessId]/details/folders/index.vue?macro=true";
import { default as indexdCKqqrY5Dc_EH_RPhUOHHku62LqxS6oINsqcVIp3ARYMeta } from "/vercel/path0/pages/businesses/[businessId]/details/activity/index.vue?macro=true";
import { default as indexKn5399yNs1nNdlNONZFQhPKyfZ_45QiCbHqj6YpR4L03sMeta } from "/vercel/path0/pages/businesses/[businessId]/details/marketing/index.vue?macro=true";
import { default as prospect_45managerY4XZD5_45C3c5Ruc3znrTvnFaMooNDmzFrpvLlbG7hKWAMeta } from "/vercel/path0/pages/businesses/[businessId]/details/prospect-manager.vue?macro=true";
import { default as acquisition_45leadsYGEsl2FNeVl48GRgqUOuq9Bs1tnKDVxote_45obySZJVMMeta } from "/vercel/path0/pages/businesses/[businessId]/details/acquisition-leads.vue?macro=true";
import { default as automation_45manager6TRl6FXBmLhNRq5iMKMOMV0d3S_I4UENkde31QzZ_40Meta } from "/vercel/path0/pages/businesses/[businessId]/details/automation-manager.vue?macro=true";
import { default as cim_45access_45managerDcLos1xTl4nxoUjxvSGb0z3LU9z7Pzzfp7K6MRTpA64Meta } from "/vercel/path0/pages/businesses/[businessId]/details/cim-access-manager.vue?macro=true";
import { default as _91folderId_93NTxlEKslVNPJ1saOJM4QQEiF9bTfr3kajH8wj5Tc29QMeta } from "/vercel/path0/pages/businesses/[businessId]/details/folders/[folderId].vue?macro=true";
import { default as confidentiality_45agreementg_FF50estOyEDqPmQ5FHxTJTv5yDV_mPiCXptYap2IYMeta } from "/vercel/path0/pages/businesses/[businessId]/details/confidentiality-agreement.vue?macro=true";
export default [
  {
    name: "email",
    path: "/email",
    component: () => import("/vercel/path0/pages/email.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/vercel/path0/pages/users.vue")
  },
  {
    name: "u-token",
    path: "/u/:token()",
    meta: _91token_930VRPgwMzhH9XwK4jQdRZJrEePo16q490OHAsEVdZTE0Meta || {},
    component: () => import("/vercel/path0/pages/u/[token].vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    component: () => import("/vercel/path0/pages/tasks/index.vue")
  },
  {
    name: "auth-profile",
    path: "/auth/profile",
    component: () => import("/vercel/path0/pages/auth/profile.vue")
  },
  {
    name: "auth-sign-in",
    path: "/auth/sign-in",
    meta: sign_45inAeSXm7rLcm3lADB0JgQ0enjQKXtwBcUIqQwii7CxY8IMeta || {},
    component: () => import("/vercel/path0/pages/auth/sign-in.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    meta: unauthorizedK0eKq87Ipcr1dfJimqi2XLyXRh97Jx31XMqzIc4bbQcMeta || {},
    component: () => import("/vercel/path0/pages/unauthorized.vue")
  },
  {
    name: "business-stats",
    path: "/business-stats",
    meta: business_45statsnYcz_45Sg8GUtQHJJVWG0WVi2gjlcefiAVLsw6YGxj0r0Meta || {},
    component: () => import("/vercel/path0/pages/business-stats.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    meta: index5XBmGkYt_45HFVtTt2RhtlIcl3hPZ6S3KpEutULHXLHZAMeta || {},
    component: () => import("/vercel/path0/pages/calendar/index.vue")
  },
  {
    name: "campaign",
    path: "/campaign",
    component: () => import("/vercel/path0/pages/campaign/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/vercel/path0/pages/contacts/index.vue")
  },
  {
    name: "oauth-exchange",
    path: "/oauth/exchange",
    meta: exchange661bhJS583nflQmXH5Y7GKUdA16aPwm4_45I_TTNNWB1QMeta || {},
    component: () => import("/vercel/path0/pages/oauth/exchange.vue")
  },
  {
    name: "pipeline",
    path: "/pipeline",
    component: () => import("/vercel/path0/pages/pipeline/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy4XTtqETNZShW4bt4tv1KYsHRfQDwaNm0MGXT0dxQJr0Meta || {},
    component: () => import("/vercel/path0/pages/privacy-policy.vue")
  },
  {
    name: "settings-brand",
    path: "/settings/brand",
    meta: brandF8XU3_CcKfxJAQI4NQoIfzoXJ78XHwoM_b4Jh8Oq4ssMeta || {},
    component: () => import("/vercel/path0/pages/settings/brand.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexv1fFzc2ShcljiGo28Bo2KD8xzvwNrH7uZVZ3jm__I8gMeta || {},
    component: () => import("/vercel/path0/pages/settings/index.vue")
  },
  {
    name: "auth-workspaces",
    path: "/auth/workspaces",
    meta: workspaces0cn2qnvuwNdSOycWVrnYQ9aDRp2zcqhfDoS4W__4533WIMeta || {},
    component: () => import("/vercel/path0/pages/auth/workspaces.vue")
  },
  {
    name: "campaign-create",
    path: "/campaign/create",
    component: () => import("/vercel/path0/pages/campaign/create.vue")
  },
  {
    name: "contracts",
    path: "/contracts",
    component: () => import("/vercel/path0/pages/contracts/index.vue")
  },
  {
    name: "data-room",
    path: "/data-room",
    meta: indexczqb894Rrptdre7iLZ86SFXmfR9zfWOMvkAXxsE7bgMMeta || {},
    component: () => import("/vercel/path0/pages/data-room/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: index_45SxPpf9CL7T2yY3RiaZ0pGGqQraQq4KVzxft0sdwROQMeta || {},
    component: () => import("/vercel/path0/pages/templates/index.vue")
  },
  {
    name: "auth-invite-id",
    path: "/auth/invite/:id()",
    meta: _91id_93rEONDoQiE79kBDm6XcfRc_45jaS9cHrGqzuBkyz7XDAGYMeta || {},
    component: () => import("/vercel/path0/pages/auth/invite/[id].vue")
  },
  {
    name: "businesses",
    path: "/businesses",
    component: () => import("/vercel/path0/pages/businesses/index.vue")
  },
  {
    name: "data-room-redeem",
    path: "/data-room/redeem",
    meta: redeem7PqwaR5F4q2ptMXieuLH8IR4wLkEHPnT6akEGkiweroMeta || {},
    component: () => import("/vercel/path0/pages/data-room/redeem.vue")
  },
  {
    name: "page-access-id",
    path: "/page-access/:id()",
    meta: _91id_93uMVwxvjG__45LYd0iNmuDtPw45H_kJGvKcfiZim5Za71gMeta || {},
    component: () => import("/vercel/path0/pages/page-access/[id].vue")
  },
  {
    name: "settings-billing",
    path: "/settings/billing",
    meta: billingb83Bs9cMUtNzaecR4ZtHkxs0OKXE3HAVmWrYFjkc_45U8Meta || {},
    component: () => import("/vercel/path0/pages/settings/billing.vue")
  },
  {
    name: "automations",
    path: "/automations",
    component: () => import("/vercel/path0/pages/automations/index.vue")
  },
  {
    name: "data-room-expired",
    path: "/data-room/expired",
    meta: expiredzIQQuwxnfvylWXWmD_98vUUHznjMovrM7vQcZmn4ErgMeta || {},
    component: () => import("/vercel/path0/pages/data-room/expired.vue")
  },
  {
    name: "data-room-sign-in",
    path: "/data-room/sign-in",
    meta: sign_45inl7EhC8W14trRKgrpz5MQ5wr8Jm2HlqXpA1uwX6IRpD8Meta || {},
    component: () => import("/vercel/path0/pages/data-room/sign-in.vue")
  },
  {
    name: "settings-business",
    path: "/settings/business",
    meta: businesspThAUmSvYp6KbNS5av2VO2EfBIEKLEN7aSo2dcrP3WYMeta || {},
    component: () => import("/vercel/path0/pages/settings/business.vue")
  },
  {
    name: "settings-features",
    path: "/settings/features",
    meta: featuresaednd1HDFRBhPUti1SP5Yb_45pJRar_lO6g7qkK6aq_451QMeta || {},
    component: () => import("/vercel/path0/pages/settings/features.vue")
  },
  {
    name: "settings-listings",
    path: "/settings/listings",
    meta: listingswMUPBReVImpzKm1_452k3BDvMzSCLoZEr19zHzEp79NfUMeta || {},
    component: () => import("/vercel/path0/pages/settings/listings.vue")
  },
  {
    name: "templates-folders",
    path: "/templates/folders",
    meta: foldersvRMB3KouJlnik1kk_458mSxBK5Zv8yOBaA4bZWuicBPOcMeta || {},
    component: () => import("/vercel/path0/pages/templates/folders.vue")
  },
  {
    name: "campaign-id",
    path: "/campaign/:id()",
    meta: indexwP03gWLiuIGVzQ1MhFUb8GR07mYYi95OsCS71UM_vWkMeta || {},
    component: () => import("/vercel/path0/pages/campaign/[id]/index.vue")
  },
  {
    name: "templates-cim",
    path: "/templates/cim",
    meta: indexY75mSzdpBxLDG_45PWRuGu2ZQKwE281eaZLkLWxi9d8qUMeta || {},
    component: () => import("/vercel/path0/pages/templates/cim/index.vue")
  },
  {
    name: "templates-forms-new",
    path: "/templates/forms/new",
    component: () => import("/vercel/path0/pages/templates/forms/new.vue")
  },
  {
    name: "templates-resources",
    path: "/templates/resources",
    meta: resourcesNbsgHUKeq_45Lh6wQhNDU5FRhnVzhkaToeKOdIwn_45Bu3MMeta || {},
    component: () => import("/vercel/path0/pages/templates/resources.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta || {},
    component: () => import("/vercel/path0/pages/auth/forgot-password.vue")
  },
  {
    name: "contracts-id-files",
    path: "/contracts/:id()/files",
    meta: filescXeN7trZn3gmRrd4WufmqqxVK_45n3JwMpfsA_45N_v3_HYMeta || {},
    component: () => import("/vercel/path0/pages/contracts/[id]/files.vue")
  },
  {
    name: "public-publicId-ca",
    path: "/public/:publicId()/ca",
    meta: caSLr1BnUYHQLXN0422h8dDuZhcSkUmMGshb96XHRA3vcMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/ca.vue")
  },
  {
    name: "settings-integration",
    path: "/settings/integration",
    meta: integrationKcPoiVKHxVz6KaWGXCGDJk_45eO9wRBAK120tvCugdtAAMeta || {},
    component: () => import("/vercel/path0/pages/settings/integration.vue")
  },
  {
    name: "templates-forms-id",
    path: "/templates/forms/:id()",
    component: () => import("/vercel/path0/pages/templates/forms/[id].vue")
  },
  {
    name: "templates-industries",
    path: "/templates/industries",
    component: () => import("/vercel/path0/pages/templates/industries.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditions0uoxVtwK_45tSMS21tRu9yb6U_45zGTAUTRZuYF7psIZXqsMeta || {},
    component: () => import("/vercel/path0/pages/terms-and-conditions.vue")
  },
  {
    name: "public-publicId-cim",
    path: "/public/:publicId()/cim",
    meta: cim5bPFTPS8SP_45LveDEPw8APP5VIFBQscn6i_UJWaFFZPMMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/cim.vue")
  },
  {
    name: "templates-cim-cimId",
    path: "/templates/cim/:cimId()",
    meta: _91cimId_93bDMp0NiOw1ypyIf0rvWU0UVo08CC3QuxsHyzOG42v3QMeta || {},
    component: () => import("/vercel/path0/pages/templates/cim/[cimId].vue")
  },
  {
    name: "templates-forms",
    path: "/templates/forms",
    meta: indexk5Fq2_d0Btb_qfF1zklG7b00LAF1ql3Y3Da90rvGoAYMeta || {},
    component: () => import("/vercel/path0/pages/templates/forms/index.vue")
  },
  {
    name: "contracts-id-details",
    path: "/contracts/:id()/details",
    meta: details5iitdEX3tLk2ls9JWWUW3tHUKfcUb_5Z7V2ZCZt7KSQMeta || {},
    component: () => import("/vercel/path0/pages/contracts/[id]/details.vue")
  },
  {
    name: "templates-teaser",
    path: "/templates/teaser",
    meta: index9wYZ4YK6fLdCidEsUvqMZMz3QnUGgODiwpyhLeQFrC8Meta || {},
    component: () => import("/vercel/path0/pages/templates/teaser/index.vue")
  },
  {
    name: "trust-accounting",
    path: "/trust-accounting",
    component: () => import("/vercel/path0/pages/trust-accounting/index.vue")
  },
  {
    name: "contracts-id-activity",
    path: "/contracts/:id()/activity",
    meta: activity_45GO0bCxJZruKWLf5YiKGKelgbfLyqAJsGY28zzaIrn0Meta || {},
    component: () => import("/vercel/path0/pages/contracts/[id]/activity.vue")
  },
  {
    name: "settings-authentication",
    path: "/settings/authentication",
    meta: authenticationw2ApG0hJeS_45qn436uxf7f0kksQz642YJv8lPXSHpWiwMeta || {},
    component: () => import("/vercel/path0/pages/settings/authentication.vue")
  },
  {
    name: "templates-message",
    path: "/templates/message",
    meta: index_45Gem6qaZmh_uN_45uIsuL81Fpxjig2_45EF5cyY7kGuWuuEMeta || {},
    component: () => import("/vercel/path0/pages/templates/message/index.vue")
  },
  {
    name: "templates-proposal-id",
    path: "/templates/proposal/:id()",
    meta: _91id_93fv0EZ1pYp3YXrYd1NYWPDxwoWLuv6yrhF_45LJPRsEL_wMeta || {},
    component: () => import("/vercel/path0/pages/templates/proposal/[id].vue")
  },
  {
    name: "public-publicId-teaser",
    path: "/public/:publicId()/teaser",
    meta: teasereXu8iOfba_45IGkAXoStp8Es0ueXxbL5KOf8CgwSP316MMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/teaser.vue")
  },
  {
    name: "templates-proposal",
    path: "/templates/proposal",
    meta: indexBUXia09MW2EtmVnp3tECSLDf0zx1E9jzd079WZ_45KnbMMeta || {},
    component: () => import("/vercel/path0/pages/templates/proposal/index.vue")
  },
  {
    name: "settings-email-compliance",
    path: "/settings/email-compliance",
    meta: email_45complianceGUSH2Rs3UrT337hPPw2Cq8Y9EwcJqC2bg9aaWRdaC5QMeta || {},
    component: () => import("/vercel/path0/pages/settings/email-compliance.vue")
  },
  {
    name: "templates-appraisal",
    path: "/templates/appraisal",
    component: () => import("/vercel/path0/pages/templates/appraisal/index.vue")
  },
  {
    name: "public-publicId-proposal",
    path: "/public/:publicId()/proposal",
    meta: proposalz3GDZSVWEZYX_MymSMPjsbkt6EXSMyh6T0IUTRi_VysMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/proposal.vue")
  },
  {
    name: "contracts-id-transactions",
    path: "/contracts/:id()/transactions",
    meta: transactionsavue2bn_45hvUFb_BD4m9MIDkfrr0_QfI55pmO6_45ZeRnEMeta || {},
    component: () => import("/vercel/path0/pages/contracts/[id]/transactions.vue")
  },
  {
    name: "public-publicId-appraisal",
    path: "/public/:publicId()/appraisal",
    meta: appraisalYS0eMI3c7NcLaj9yO99qdEiF5yO76Ht4emmG9kbGNmoMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/appraisal.vue")
  },
  {
    name: "templates-teaser-teaserId",
    path: "/templates/teaser/:teaserId()",
    meta: _91teaserId_93_qAzEPydN1EPjEn0cfRt8pX0t3scCESof5QNaTZ0pncMeta || {},
    component: () => import("/vercel/path0/pages/templates/teaser/[teaserId].vue")
  },
  {
    name: "trust-accounting-id",
    path: "/trust-accounting/:id()",
    component: () => import("/vercel/path0/pages/trust-accounting/[id]/index.vue")
  },
  {
    name: "contacts-contactId-profile",
    path: "/contacts/:contactId()/profile",
    meta: profile4aI4jykUj6PdLdO7NBzQZ6C42XpTKE_PjdGk151K8bEMeta || {},
    component: () => import("/vercel/path0/pages/contacts/[contactId]/profile.vue")
  },
  {
    name: "public-publicId-public-cim",
    path: "/public/:publicId()/public-cim",
    meta: public_45cimlCNf49riXn83S3OzQfh21jDYJQNJ36zM6UW44TKuzxIMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/public-cim.vue")
  },
  {
    name: "auth-forgot-password-callback",
    path: "/auth/forgot-password-callback",
    meta: forgot_45password_45callbackwvXI1oTz2BPssbRqs_tybIP2PxdJLiLn_451z2tvnpGI0Meta || {},
    component: () => import("/vercel/path0/pages/auth/forgot-password-callback.vue")
  },
  {
    name: "contacts-contactId-activity",
    path: "/contacts/:contactId()/activity",
    meta: activityUrh38EUilOOtEMJH1cxq9EJQiPPFIjkDKilSUSdsrZAMeta || {},
    component: () => import("/vercel/path0/pages/contacts/[contactId]/activity.vue")
  },
  {
    name: "public-publicId-file-upload",
    path: "/public/:publicId()/file-upload",
    meta: file_45uploadCJ_xRxbneczffDnMfmr8PuzRSWHjkPMGWocMmxN7vzkMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/file-upload.vue")
  },
  {
    name: "contacts-contactId-automation",
    path: "/contacts/:contactId()/automation",
    meta: automationAzQSmK_TwhODXkkOx_45PS_45ufZsEUilpuGhDt92eY4h34Meta || {},
    component: () => import("/vercel/path0/pages/contacts/[contactId]/automation.vue")
  },
  {
    name: "public-publicId-buyer-profile",
    path: "/public/:publicId()/buyer-profile",
    meta: buyer_45profileb60sIKfnshtS_VEHQbtWPt2oRrgo6RH_455K0ser3XwhwMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/buyer-profile.vue")
  },
  {
    name: "public-publicId-vendor-report",
    path: "/public/:publicId()/vendor-report",
    meta: vendor_45reportDmiZpzTMdAA_2_hlC0XeXQex_qZQcNlVmaIX3Js1YdQMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/vendor-report.vue")
  },
  {
    name: "automations-automationId",
    path: "/automations/:automationId()",
    component: () => import("/vercel/path0/pages/automations/[automationId]/index.vue")
  },
  {
    name: "public-publicId-embed-listings",
    path: "/public/:publicId()/embed/listings",
    meta: listingscSMEtcJBF1tcjz14HVcUJ1LXCdnVBgULhRpFtrZzU8EMeta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/embed/listings.vue")
  },
  {
    name: "businesses-businessId-appraisal",
    path: "/businesses/:businessId()/appraisal",
    meta: appraisalMtpTnWDID5Wk6nwrkrVWRyt19MARWPOjMBblqS6JubkMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/appraisal.vue")
  },
  {
    name: "businesses-businessId-cim",
    path: "/businesses/:businessId()/cim",
    component: () => import("/vercel/path0/pages/businesses/[businessId]/cim/index.vue")
  },
  {
    name: "public-publicId-file-upload-old",
    path: "/public/:publicId()/file-upload-old",
    meta: file_45upload_45oldrYGNyCs3VBAFBZ7zAFySV04WgYL9pDak9AplqmFRW98Meta || {},
    component: () => import("/vercel/path0/pages/public/[publicId]/file-upload-old.vue")
  },
  {
    name: "templates-business-campaign",
    path: "/templates/business-campaign",
    meta: indexay4IrCx9SmYsYLz_qxxV_45MnaNem2jWgtMz4wuoCyVMIMeta || {},
    component: () => import("/vercel/path0/pages/templates/business-campaign/index.vue")
  },
  {
    name: "businesses-businessId-details-vdr",
    path: "/businesses/:businessId()/details/vdr",
    meta: vdrgFE4bgftp6gtCBW3NtqZWr14b1HRqqeBtTLkSx9zBIAMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/vdr.vue")
  },
  {
    name: "businesses-businessId-teaser",
    path: "/businesses/:businessId()/teaser",
    component: () => import("/vercel/path0/pages/businesses/[businessId]/teaser/index.vue")
  },
  {
    name: "trust-accounting-bank-statement-id",
    path: "/trust-accounting/bank-statement/:id()",
    component: () => import("/vercel/path0/pages/trust-accounting/bank-statement/[id].vue")
  },
  {
    name: "contacts-contactId-advanced-profile",
    path: "/contacts/:contactId()/advanced-profile",
    meta: advanced_45profile0zHqn5QWuz640nlWwwbYgVYhtTx7U2JQ6SV8DAjwhAYMeta || {},
    component: () => import("/vercel/path0/pages/contacts/[contactId]/advanced-profile.vue")
  },
  {
    name: "businesses-businessId-details-teaser",
    path: "/businesses/:businessId()/details/teaser",
    meta: teaserUQJpBodaNKjpDpv1hhvfCSdX1pUU0Xk5GODHKdgTnoYMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/teaser.vue")
  },
  {
    name: "businesses-businessId-proposal",
    path: "/businesses/:businessId()/proposal",
    component: () => import("/vercel/path0/pages/businesses/[businessId]/proposal/index.vue")
  },
  {
    name: "automations-automationId-events",
    path: "/automations/:automationId()/events",
    component: () => import("/vercel/path0/pages/automations/[automationId]/events/index.vue")
  },
  {
    name: "businesses-businessId-details-profile",
    path: "/businesses/:businessId()/details/profile",
    meta: profileLb7ikmtg03EPgB7TamGHKbI4lerMW5S9MuIQzNj4qZ4Meta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/profile.vue")
  },
  {
    name: "businesses-businessId-details-sharing",
    path: "/businesses/:businessId()/details/sharing",
    meta: sharing8PV3u5_8tSLX03OjVmfijF3x5Wd0Fce8jQOLQxd3vOoMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/sharing.vue")
  },
  {
    name: "businesses-businessId-details-recorder",
    path: "/businesses/:businessId()/details/recorder",
    meta: recorderXVHTZGB5wdHL2ho5ZoL1i1vzZHAKBm0NTN4V_BZxqY0Meta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/recorder.vue")
  },
  {
    name: "trust-accounting-ledger-ledgerId",
    path: "/trust-accounting/ledger/:ledgerId()",
    component: () => import("/vercel/path0/pages/trust-accounting/ledger/[ledgerId]/index.vue")
  },
  {
    name: "trust-accounting-ledger-transaction-id",
    path: "/trust-accounting/ledger/transaction/:id()",
    meta: _91id_93Z_ti9nadJUsWpbDet1kUTK9y0EhCj1eHVwdznOwbbvAMeta || {},
    component: () => import("/vercel/path0/pages/trust-accounting/ledger/transaction/[id].vue")
  },
  {
    name: "businesses-businessId-details-analytics",
    path: "/businesses/:businessId()/details/analytics",
    meta: analyticsWubLrN1ch_JAEuzVc27NpPIeFkJNn0LKVK6ojuOaVz8Meta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/analytics.vue")
  },
  {
    name: "templates-confidentiality-agreement",
    path: "/templates/confidentiality-agreement",
    meta: indexzNvj00bacJkaeqABj__vccp_45petnkcbgtmnUH62aaYYMeta || {},
    component: () => import("/vercel/path0/pages/templates/confidentiality-agreement/index.vue")
  },
  {
    name: "businesses-businessId-details-file-sharing",
    path: "/businesses/:businessId()/details/file-sharing",
    meta: file_45sharingub1XUBE9Aez1xCPyiVYHRVLvbeHU1Z_CCMDOVcKdzCIMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/file-sharing.vue")
  },
  {
    name: "businesses-businessId-details-folders",
    path: "/businesses/:businessId()/details/folders",
    meta: index2ngvYzCNiU3gZwe31mrknqs_65F0chrR9zg1tMQ8bWAMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/folders/index.vue")
  },
  {
    name: "businesses-businessId-details-activity",
    path: "/businesses/:businessId()/details/activity",
    meta: indexdCKqqrY5Dc_EH_RPhUOHHku62LqxS6oINsqcVIp3ARYMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/activity/index.vue")
  },
  {
    name: "businesses-businessId-details-marketing",
    path: "/businesses/:businessId()/details/marketing",
    meta: indexKn5399yNs1nNdlNONZFQhPKyfZ_45QiCbHqj6YpR4L03sMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/marketing/index.vue")
  },
  {
    name: "businesses-businessId-details-prospect-manager",
    path: "/businesses/:businessId()/details/prospect-manager",
    meta: prospect_45managerY4XZD5_45C3c5Ruc3znrTvnFaMooNDmzFrpvLlbG7hKWAMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/prospect-manager.vue")
  },
  {
    name: "businesses-businessId-details-acquisition-leads",
    path: "/businesses/:businessId()/details/acquisition-leads",
    meta: acquisition_45leadsYGEsl2FNeVl48GRgqUOuq9Bs1tnKDVxote_45obySZJVMMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/acquisition-leads.vue")
  },
  {
    name: "businesses-businessId-details-automation-manager",
    path: "/businesses/:businessId()/details/automation-manager",
    meta: automation_45manager6TRl6FXBmLhNRq5iMKMOMV0d3S_I4UENkde31QzZ_40Meta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/automation-manager.vue")
  },
  {
    name: "businesses-businessId-details-cim-access-manager",
    path: "/businesses/:businessId()/details/cim-access-manager",
    meta: cim_45access_45managerDcLos1xTl4nxoUjxvSGb0z3LU9z7Pzzfp7K6MRTpA64Meta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/cim-access-manager.vue")
  },
  {
    name: "businesses-businessId-details-folders-folderId",
    path: "/businesses/:businessId()/details/folders/:folderId()",
    meta: _91folderId_93NTxlEKslVNPJ1saOJM4QQEiF9bTfr3kajH8wj5Tc29QMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/folders/[folderId].vue")
  },
  {
    name: "businesses-businessId-details-confidentiality-agreement",
    path: "/businesses/:businessId()/details/confidentiality-agreement",
    meta: confidentiality_45agreementg_FF50estOyEDqPmQ5FHxTJTv5yDV_mPiCXptYap2IYMeta || {},
    component: () => import("/vercel/path0/pages/businesses/[businessId]/details/confidentiality-agreement.vue")
  }
]